// LOCAL STORAGE FIELDS
export const SERVER_URL = 'SERVER_URL';
// export const API_KEY_HEADER = 'X-API-Key';
export const WEBSOCKET_URL = 'WEBSOCKET_URL';
